import React, { Component } from 'react';

import { InputBlock } from 'components/input';
import { Panel } from 'components/panel';
import { Radiolist } from 'components/radiolist';
import intersectionWith from 'lodash/intersectionWith';
import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';

class PanelRadioList extends Component {
  static propTypes = {
    allowUncheck: PropTypes.bool,
    labelValue: PropTypes.string,
    panelLabel: PropTypes.string,
    formatItem: PropTypes.func,
    items: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    selectedOptions: PropTypes.array
  };

  isMatch(a, b) {
    if (a.key === b.offerKey || b.key === b.offerKey) {
      return true;
    }

    return isEqual(a, b);
  }

  getSelectedOption(items, checkedItems) {
    if (checkedItems) {
      const checked = intersectionWith(items, checkedItems, this.isMatch);

      if (checked[0] && checked[0].offerKey) {
        return checked[0].offerKey;
      } else if (checked[0] && checked[0].key) {
        return checked[0].key;
      }
    }

    return '';
  }

  renderRadio(items, key) {
    const { formatItem, allowUncheck, selectedOptions, ...props } = this.props;
    const selectedOption = this.getSelectedOption(items, selectedOptions);

    return (
      <Radiolist
        {...props}
        selectedOption={selectedOption}
        key={key}
        formatItem={formatItem}
        allowUncheck={allowUncheck}
        items={items}
      />
    );
  }

  render() {
    const { labelValue, panelLabel, items, ...props } = this.props;

    return (
      <InputBlock {...props} labelValue={labelValue}>
        <div>
          {items && (
            <Panel header={panelLabel} nopadding>
              {items && !Array.isArray(items)
                ? Object.keys(items).map((key) => {
                    return this.renderRadio(items[key], key);
                  })
                : this.renderRadio(items, '0')}
            </Panel>
          )}
        </div>
      </InputBlock>
    );
  }
}

export default PanelRadioList;
